import { ApplicationEnum } from "../../enums/ApplicationEnum";

interface StatusType {
    [key: number]: number[];
}

export const hhTaskStatus: StatusType = {
    1: [245, 425, 426, 441, 445, 455, 460, 480],
    2: [420, 215, 420, 421, 485, 418],
    3: [220],
    4: [225],
    5: [240],
    6: [450],
    7: [210, 415, 440, 475],
    8: [205, 405],
    9: [230, 430, 465, 470],
    10: [235, 435],
    11: [400],
    12: [402],
    13: [401],
    14: [403],
    15: [200, 410]
};

export const hcTaskStatus: StatusType = {
    1: [425, 445, 455, 460],
    2: [420, 215, 211, 419, 444],
    3: [220],
    4: [225],
    5: [240],
    6: [450],
    7: [210, 415],
    8: [205, 405],
    9: [230, 430, 465, 470],
    10: [235, 435],
    11: [400],
    12: [402],
    13: [401],
    14: [403],
    15: [200, 410]
};

export const hosPalTaskStatus: StatusType = {
    1: [8, 10, 11],
    2: [4, 5],
    3: [6],
    4: [7],
    5: [14],
    6: [9],
    7: [3, 15],
    8: [2],
    9: [12],
    10: [13, 16],
    11: [17],
    12: [18],
    13: [19],
    14: [20],
    15: [1]
};

export const getTaskStatus = (application: number, status: number) => {
    if (application === ApplicationEnum.AgencyCore) {
        return hhTaskStatus[status];
    } else if (application === ApplicationEnum.HomeCare) {
        return hcTaskStatus[status];
    } else {
        return hosPalTaskStatus[status];
    }
};
